<div [class.common-ui-card-danger]="type === 'danger'"
     [class.common-ui-card-info]="type === 'info'"
     [class.common-ui-card-warning]="type === 'warning'"
     class="card dna-card-info common-ui-card">
  <div class="common-ui-card-img">
    <em [class.icon-fi-fehler]="type === 'danger' || type === 'eric-error'"
        [class.icon-fi-info]="type === 'info'"
        [class.icon-fi-warning]="type === 'warning'"
        class="icon icon-svg">
    </em>
  </div>
  <div [class.common-ui-card-eric-error-message]="type === 'eric-error'" [innerHTML]="message" class="use-wrap"></div>
</div>
